import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

import Client from './components/Client';
import Promotion from './components/Promotion';
import PromotionsFilters from './components/PromotionsFilters';
import Visibility from './Visibility';

class Promotions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client('none'),
      promotions: null,
      addNewPromotion: false,
      filterData: undefined,
    };

    this.applyFilters = this.applyFilters.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.promotionUpdated = this.promotionUpdated.bind(this);
    this.getData = this.getData.bind(this);

    this.restricted = new Visibility('promotions');
    this.filtersRef = React.createRef();
  }

  componentDidMount() {
    if (this.restricted.scope.visible) this.getData();
  }

  getData() {
    const queryData = { limit: 20, orderBy_createdOn: true, with_price_warning: 1 };
    const data = this.state.client.getPromotions(queryData);

    if (data?.promotions) {
      this.setState({ promotions: data.promotions });
    }
  }

  applyFilters(queryData) {
    const finalQuery = { limit: 20, ...queryData, with_price_warning: 1 };
    const data = this.state.client.filterPromotions(finalQuery);

    if (data?.promotions) {
      this.setState({
        promotions: data.promotions,
        filterData: finalQuery
      });
    }
  }

  toggleAdd() {
    if (!this.restricted.scope.edit) return;
    this.setState((s) => ({ addNewPromotion: !s.addNewPromotion }));
    window.scrollTo(0, 0);
  }

  promotionUpdated(savedPromotion, previousIref) {
    const refreshCurrent = () => {
      if (this.state.filterData) {
        this.applyFilters(this.state.filterData);
      } else {
        this.getData();
      }
    };

    if (savedPromotion) {
      this.setState((state) => {
        const current = Array.isArray(state.promotions)
          ? state.promotions
          : [];
        const existingIndex = current.findIndex((promotion) => (
          String(promotion.iref) === String(previousIref)
          || String(promotion.iref) === String(savedPromotion.iref)
        ));
        const promotions = [...current];
        if (existingIndex >= 0) {
          promotions[existingIndex] = savedPromotion;
        } else {
          promotions.unshift(savedPromotion);
        }
        return {
          promotions,
          addNewPromotion: false,
        };
      }, refreshCurrent);
    } else {
      this.setState(
        { addNewPromotion: false },
        refreshCurrent,
      );
    }

    // 🔁 reset +/– button in PromotionsFilters
    if (this.filtersRef?.current) {
      this.filtersRef.current.setState({ addNew: false });
    }
  }

  render() {
    if (!this.restricted.scope.visible) return <div />;

    let promotionsList = null;
    let promotionsCounter = 0;

    if (this.state.promotions) {
      promotionsCounter = this.state.promotions.length;
      promotionsList = this.state.promotions.map((promotion) => (
        <Promotion
          key={promotion.iref}
          promotion={promotion}
          promotionUpdated={this.promotionUpdated}
          allowEdit={this.restricted.scope.edit}
        />
      ));
    }

    return (
      <div style={{ backgroundColor: '#273442', minHeight: '100%' }}>
        <div className="sticky">
          <PromotionsFilters
            ref={this.filtersRef}
            applyFilters={this.applyFilters}
            toggleAdd={this.toggleAdd}
            promotionsCounter={promotionsCounter}
            allowEdit={this.restricted.scope.edit}
          />
        </div>

        {this.state.addNewPromotion ? (
          <Promotion
            key={0}
            promotion={undefined}
            isNew={true}
            promotionUpdated={this.promotionUpdated}
            onCancel={this.toggleAdd}
            allowEdit={this.restricted.scope.edit}
          />
        ) : null}

        {!this.state.promotions ? (
          <Box sx={{ p: 2 }}>
            <Skeleton animation="wave" variant="rounded" width={800} height={180} />
            <Skeleton animation="wave" variant="rounded" width={800} height={180} sx={{ mt: 1 }} />
          </Box>
        ) : (
          promotionsList
        )}
      </div>
    );
  }
}

export default Promotions;
